import authLoginImage from "../Images/authlogin.png";
import propertyImage from "../Images/property.png";
import smsImage from "../Images/sms.png";
import recomImage from "../Images/recom.png";
import blogImage from "../Images/blogfirst.png";
import cryptoImage from "../Images/cryptoerw.png";
import ecommerceImage from "../Images/sofa.png";
import wheatherimage from "../Images/weather.png"
import map from "../Images/map.png"
import crop from "../Images/MLPIPELINE.png"
import infinty from "../Images/infinity.png"
export const projectsData = [
  {
    title:"infinity (Social Media)",
    image:infinty,
    github:"https://github.com/Tinu01kumar/infinity-social-media-app",
    live:"https://infinty-frontend-2.onrender.com/",
    tags: ['Backend'],
    description: "Social Connectivity: Enabled users to send friend requests and follow others , post blog. ",

  },

  {
    title: 'Blogging Website',
    image: blogImage,
    youtube: 'https://youtu.be/L8OO2ANRaoE',
    github: 'https://github.com/Tinu01kumar/blog_website',
    description: 'A full-featured blogging platform for creating and managing blogs.',
    tags:['Backend']
  },
  {
    title: ' Login & Signup',
    image: authLoginImage,
    youtube: 'https://www.youtube.com/watch?v=dOBifleswfA',
    github: 'https://github.com/Tinu01kumar/fullauthbackend',
    live: 'https://super-kringle-25170f.netlify.app/',
    description: 'A full authentication and authorization system including login and signup functionality.',
    tags:['Backend']
  },
  {
    title: 'SMS Spam Classifier',
    image: smsImage,
    youtube: 'https://youtu.be/RkhGeRzi_CU',
    github: 'https://github.com/Tinu01kumar/sms_spam_classifier',
    description: 'A machine learning model to classify SMS messages as spam or ham.',
    tags:['ML']
  },
  {
    title: 'Movie Recommendation System',
    image: recomImage,
    youtube: 'https://youtu.be/0d3ZJVxOYro',
    github: 'https://github.com/Tinu01kumar/Movie_Recommendation_project-_in_python',
    description: 'A recommendation system that suggests movies based on user input.',
    tags:['ML']
  },

  {
    title: "Crop Yield Prediction(ML PIPELINE)",
    image: crop,

    github: "https://github.com/Tinu01kumar/Crop_prediction_ml_pipeline",
    
    description: 'A crop yield prediction system determine the future production by analyzing various factors.',
    tags:['ML']
  },

  {
    title: 'Property Dealer',
    image: propertyImage,
    youtube: 'https://youtu.be/p9QOE0oHh_0',
    github: 'https://github.com/Tinu01kumar/frontend_property_dealer',
    live: 'https://clever-quokka-3799f1.netlify.app/',
    description: 'A website for property dealers with comprehensive features.',
    tags:['Frontend']
  },
  {
    title: 'Cryptocurrency Website',
    image: cryptoImage,
    youtube: 'https://youtu.be/RxymB-0iHAc',
    github: 'https://github.com/Tinu01kumar/cryptocurrency_web',
    live: 'https://fabulous-blini-dc9df3.netlify.app/',
    description: 'A website to track and trade various cryptocurrencies.',
    tags:['Frontend']
  },
  {
    title: 'Ecommerce Website',
    image: ecommerceImage,
    youtube: 'https://youtu.be/I6Qinl95fbI',
    github: 'https://github.com/Tinu01kumar/furniture',
    live: 'https://tinu01kumar.github.io/furniture/index.html',
    description: 'An e-commerce platform ,  my first project',
    tags:['Frontend']
  },


  {
    title: "Find shortest path on map",
    image: map,

    github: "https://github.com/Tinu01kumar/locate_map",
    live: "https://tinu01kumar.github.io/locate_map/",
    description: 'Find the shortest path between two points based on javascript.',
    tags:['Frontend']
  },


  {
    title: "Weather app(geolocation)",
    image: wheatherimage,

    github: "https://github.com/Tinu01kumar/weather_app",
    live: "https://mausamkahaalchaal.netlify.app/",
    description: 'Determine weather of location by fetching information from weather api.',
    tags:['Fontend']
  },




];
